import React from 'react'
import IconClose from '../svgs/Close'
import IconInfo from '../svgs/Info'

interface Props {
  open: boolean
  onClick: (e: React.MouseEvent<HTMLElement>) => void
}

const ToolTip: React.FunctionComponent<Props> = ({ children, open, onClick }) => {
  return (
    <div className="tooltip-wrap">
      <span className="tooltip-btn" onClick={(e) => onClick(e)}>
        {open ? <IconClose /> : <IconInfo />}
      </span>
      {open && <div className="tooltip-text">{children}</div>}
    </div>
  )
}

export default ToolTip